// =============================================================================
// NotFound — the card for an address the app does not know (UI-NAV-042).
//
// Used by the catch-all route (an unknown path like /shipping used to render a
// blank page) and by the dynamic module pages when the slug matches no menu the
// user can see (they used to spin on "Loading search configuration..." forever).
// =============================================================================
import React from "react";
import { useNavigate } from "react-router-dom";
import { FaCompass } from "react-icons/fa";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="qw-root content-halo content-halo-narrow" style={{
      maxWidth: 520, margin: "120px auto", padding: "36px 32px",
      borderRadius: 16, textAlign: "center",
    }}>
      <FaCompass style={{ fontSize: 34, color: "#94A3B8" }} />
      <h4 style={{ marginTop: 14, color: "#0F172A", fontWeight: 700 }}>Page not found</h4>
      <p style={{ color: "#64748B", fontSize: 14 }}>
        This address does not match any page you can open. Check the link, or
        use the menu to find the page.
      </p>
      <button className="qw-btn qw-btn-primary qw-btn-sm" onClick={() => navigate("/home")}>
        Back to home
      </button>
    </div>
  );
}
